<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="currentColor"
  class="size-5 transition-transform duration-200"
  [ngClass]="isOpen ? 'rotate-180' : ''"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="m11.25 6.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 8m-9-3.75h.008v.008H12V4.25Z"
  />
  <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 10.75-7.5 7.5-7.5-7.5" />
</svg>
